const navMainLinks = document.querySelectorAll(
    "a.nav-primary__main-links__item"
);
navMainLinks &&
    navMainLinks.forEach(link =>
        link.addEventListener("click", event => {
            const text = link.querySelector("span").innerText;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "navigation",
                section: "header",
                sub_section: "nav primary main link",
                element: text,
                "Interaction type": "navigation",
            });
        })
    );

const navSecondaryLinks = document.querySelectorAll(
    "a.nav-primary__account-links__item"
);

navSecondaryLinks &&
    navSecondaryLinks.forEach(link =>
        link.addEventListener("click", event => {
            const text = link.innerText;
            console.log(text);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "navigation",
                section: "header",
                sub_section: "nav primary account link",
                element: text,
                "Interaction type": "navigation",
            });
        })
    );

const footerQuickLinks = document.querySelectorAll(".footer-primary__link");

footerQuickLinks &&
    footerQuickLinks.forEach(link =>
        link.addEventListener("click", event => {
            const text = link.querySelector("span").innerText;
            console.log(text);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "navigation",
                section: "footer",
                sub_section: "footer quick link",
                element: text,
                "Interaction type": "navigation",
            });
        })
    );

const footerSalesRepLinks = document.querySelectorAll(
    ".footer-primary__sales-rep a.button"
);

footerSalesRepLinks &&
    footerSalesRepLinks.forEach(link =>
        link.addEventListener("click", event => {
            const text = link.querySelector("span").innerText;
            console.log(text);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "navigation",
                section: "footer",
                sub_section: "footer primary sales rep link",
                element: text,
                "Interaction type": "navigation",
            });
        })
    );

const footerProductInfoLink = document.getElementById("product_info_download");

footerProductInfoLink &&
    footerProductInfoLink.addEventListener("change", event => {
        console.log(event.target.options[event.target.selectedIndex].text);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "navigation",
            section: "footer",
            sub_section: "footer product info download link",
            element: event.target.options[event.target.selectedIndex].text,
            "Interaction type": "navigation",
        });
    });

// print icon
const printIcons = document.querySelectorAll(".icon-print");
printIcons &&
    printIcons.forEach(printIcon =>
        printIcon.addEventListener("click", event => {
            window.ga("send", "event", {
                eventCategory: "PDF Download",
                eventAction: `Download ${printIcon.parentNode.getAttribute(
                    "href"
                )}`,
                eventLabel: window.location.pathname,
            });
        })
    );
